import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DialogModule } from 'primeng/dialog';

@Component({
  selector: 'stupa-mobile-drawer',
  standalone: true,
  imports: [CommonModule, DialogModule],
  templateUrl: './mobile-drawer.component.html',
  styleUrl: './mobile-drawer.component.scss',
})
export class MobileDrawerComponent {
  @Input() show_mobile_drawer = false;
  /** When true, drawer uses a fixed height (90dvh) with pinned header/footer. */
  @Input() drawerExtended = false;
  /** Extra class(es) on the body-appended dialog for caller-specific chrome. */
  @Input() panelStyleClass = '';
  @Output() close_mobile_drawer = new EventEmitter<void>();

  get drawerPanelStyleClass(): string {
    const extended = this.drawerExtended ? 'drawer-extended' : 'drawer-normal';
    const extra = (this.panelStyleClass ?? '').trim();
    return extra ? `mobile-drawer ${extended} ${extra}` : `mobile-drawer ${extended}`;
  }

  close() {
    this.close_mobile_drawer.emit();
  }
}
